import ImageDashboard from "../../../../components/image-manager/ImageDashboard";

const AllImages = () => {

    return (
        <ImageDashboard
            title="All Images"
            api="/images"
            fetchEndpoint="/api/images"
            uploadEndpoint="/upload"
            reorderEndpoint="/api/images/image/reorder"
            renameEndpoint="/api/images/image/rename"
            deleteEndpointBase="/api/images/image"
            allowReorder={true}
        />
    )
}

export default AllImages